import { memo, useEffect, useCallback } from 'react';
import './index.less';
// import bannerImage from '@/assets/images/login/banner.png';
import bannerImage from '@/assets/images/login/login_bg.jpg';
import rjBannerImage from '@/assets/images/login/rj_cover.jpg';
// import { apiGetVersionInfo } from '@/views/updater/server';
import { loginCollectV2 } from '../collect/loginCollect';
import { apiActiveReport } from '@/views/login/server';
import { REPORTED_KEY } from '@/views/login/types';
import LocalStore from '@/utils/store';
import AdminConfig from '@/config';
import { removeLocalStorage, getLocalStorage } from '@/utils/localStorage';
import { clearElectronLocalData } from '@/views/system/homePage/openServerList/utils';
// import { apiGetIgnoreLiveByChannel } from '@/views/system/homePage/server';
import { useLoginChannelLogo } from '../hooks/useLoginChannelLogo';
function LoginBackground(props: any) {
  const { children } = props;
  const bannerImg = useLoginChannelLogo(bannerImage, rjBannerImage, { scene: 'banner' });
  // useEffect(() => {
  //   apiGetIgnoreLiveByChannel().then(res => {
  //     const { data } = res;
  //     localStorage.removeItem('IGNORELIVEBYCHANNEL');
  //     if (data.live_status === 1) {
  //       localStorage.setItem('IGNORELIVEBYCHANNEL', '1');
  //     }
  //   });
  // }, []);

  useEffect(() => {
    LocalStore.removeValue('BASE_HOME_ADVERTSINFO');
    LocalStore.removeValue('VOICE_CLOSE_STATE');
    LocalStore.removeValue('VOICECOMMUNITY_CLOSE_STATE');
    LocalStore.removeValue('VOICECOMMUNITY_GAME_CLOSE_STATE');
    LocalStore.removeValue('VOICE_LIVEVOICE_CHECKTIP');
    LocalStore.removeValue('BASE_INFO_STATE');
    LocalStore.removeValue('SIGN_CLOSE_STATE');
    LocalStore.removeValue('SIGN_CHAT_USERID');
    LocalStore.removeValue('SERVICE_CLOSE_STATE');
    LocalStore.removeValue('LIVENOTICE_CLOSE_STATE');
    LocalStore.removeValue('CHATNOTICE_CLOSE_STATE');
    LocalStore.removeValue('LIVERAFFLE_CLOSE_STATE');
    LocalStore.removeValue(AdminConfig.serviceWinId);
    LocalStore.removeValue(AdminConfig.MESSAGE_WINID);
    LocalStore.removeValue('VOICE_BASE_FOLLOW_ANCHOR');
    LocalStore.removeValue('NAV_TABBTN_ID');
    LocalStore.removeValue('NAV_SHOW_PREFECTURE');
    removeLocalStorage('NoticeStatus');
    removeLocalStorage('serviceEnd');
    removeLocalStorage('NewMsgStatus');
    removeLocalStorage('reconnection');
    removeLocalStorage('refreshDataNewMsg');
    removeLocalStorage('sessionUrl');
    removeLocalStorage('openExternalBrowerDownLoad');
    removeLocalStorage('notifyForNewMsg');
    removeLocalStorage(AdminConfig.NOTICE_WINID);
    clearElectronLocalData();
    // const strVersion: any = localStorage.getItem('appv')?.replace(/&.+/, '');
    // let numVersion = strVersion.replace(/[^0-9]/g, '');
    // const mainVersion = numVersion.slice(0, 3);
    // const isVersion = Number(mainVersion) >= 380;
    // localStorage.setItem('MESSAGESTATUS', String(isVersion));
  }, []);

  const electronVersion = useCallback(() => {
    if ((window as any).raw) {
      (window as any).raw.getVersion({}, async (data: any) => {
        console.log(data);
        // localStorage.setItem('appv', '2.7.0');
        // const res = (await apiGetVersionInfo({
        //   app_version: data.data
        // })) as any;
        // if (res.data.app_status) {
        //   (window as any).raw.openDownloadWindow({ type: res.data.app_status }, (e: any) => console.log(e));
        // }
      });
      (window as any).raw.getmac({}, (res: any) => {
        console.log(res);
        localStorage.setItem('mac', res.data.mac);
        localStorage.setItem('os', res.data.os);
      });
    } else {
      if (!localStorage.getItem('appv')) {
        localStorage.setItem('appv', '3.9.0');
      }
    }
  }, []);
  const collectYklk = async () => {
    const hisArr = getLocalStorage(REPORTED_KEY) ? getLocalStorage(REPORTED_KEY) : '';
    const paramArr = hisArr.split('#');
    if (paramArr[1] && paramArr[1] === 'yklk') {
      const res = await apiActiveReport({
        clickId: paramArr[0]
      });
      console.log(res, 111);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      electronVersion();
    }, 100);
  }, [electronVersion]);

  Window['firstInstall'] = function () {
    loginCollectV2('0000', 1);
  };
  // Window['checkUpdate'] = function () {
  //   if ((window as any).raw) {
  //     (window as any).raw.getVersion({}, async (data: any) => {
  //       console.log(data);
  //       localStorage.setItem('appv', data.data);
  //       const res = (await apiGetVersionInfo({
  //         app_version: data.data
  //       })) as any;
  //       if (res.data.app_status) {
  //         (window as any).raw.openDownloadWindow({ type: res.data.app_status }, (e: any) => console.log(e));
  //       }
  //     });
  //   } else {
  //     localStorage.setItem('appv', '1.0.0');
  //   }
  // };
  Window['firstInstall'] = function (res: number) {
    // console.log(res);
    loginCollectV2('0000', res);
    if (res === 1) collectYklk(); // 1为第一次安装激活
  };
  return (
    <div className="login_background">
      <img className="banner_img" src={bannerImg || ''} alt="" />
      <div className="main_box">{children}</div>
    </div>
  );
}
export default memo(LoginBackground);
